import { MiddlewareAPI } from "@/lib/axios";

interface FetcherOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: string;
  headers?: Record<string, string>;
}

export const fetcher = async (url: string, options?: FetcherOptions | number) => {
  if (typeof options === 'number') {
    const res = await MiddlewareAPI.get(url, {
      headers: {
        prefer: `odata.include-annotations=*,return=representation,odata.maxpagesize=${options}`,
      },
    });
    return res.data;
  }

  if (!options || options.method === 'GET') {
    const res = await MiddlewareAPI.get(url);
    return res.data;
  }

  const { method, body, headers } = options;
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  let res;
  switch (method) {
    case 'POST':
      res = await MiddlewareAPI.post(url, body ? JSON.parse(body) : undefined, config);
      break;
    case 'PUT':
      res = await MiddlewareAPI.put(url, body ? JSON.parse(body) : undefined, config);
      break;
    case 'PATCH':
      res = await MiddlewareAPI.patch(url, body ? JSON.parse(body) : undefined, config);
      break;
    case 'DELETE':
      res = await MiddlewareAPI.delete(url, config);
      break;
    default:
      res = await MiddlewareAPI.get(url, config);
  }

  return res.data;
};
